<template>
  <div>
    <!-- <vx-card v-can="'view-site'"  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Site Name</label>

          <vs-input type="search"  placeholder="Search.." v-model="filters['site_name']" class="mb-4 md:mb-0 w-full"/>
        </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                  <label class="text-sm opacity-100 text-bold">Address Line 01</label>

                  <vs-input type="search"  placeholder="Search.." v-model="filters['address_line1']" class="mb-4 md:mb-0 w-full"/>
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                  <label class="text-sm opacity-100 text-bold">Site Telephone</label>

                  <vs-input type="search"  placeholder="Search.." v-model="filters['site_telephone']" class="mb-4 md:mb-0 w-full"/>
                </div>

      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card> -->
    <div class="vx-row" v-can:any="['view-site', 'create-site']">
      <div class="vx-col w-full">
        <vx-card>
          <template slot="actions">
              <vs-button @click="onCLickCreateManufacturing" 
                class="mr-4" color="primary" type="filled" v-can="'create-site'">
                Create
              </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input v-can="'view-site'" icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table v-can="'view-site'" :data="manufacturing_sites"  @sort="handleSort"   stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="name">SITE NAME</vs-th>
                <vs-th sort-key="name">ADDRESS LINE 01</vs-th>
                <vs-th sort-key="name">ADDRESS LINE 02</vs-th>
                <vs-th sort-key="name">SITE TELEPHONE</vs-th>
                <vs-th sort-key="name">SITE EMAIL</vs-th>
                <vs-th sort-key="name">STATUS</vs-th>
                <vs-th >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewManufacturing(data[indextr].id)"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].site_name">
                    {{ data[indextr].site_name }}
                  </vs-td>
                  <vs-td :data="data[indextr].address_line1">
                    {{ data[indextr].address_line1 }}
                  </vs-td>
                  <vs-td :data="data[indextr].address_line2">
                    {{ data[indextr].address_line2 }}
                  </vs-td>
                  <vs-td :data="data[indextr].site_telephone">
                    {{ data[indextr].site_telephone }}
                  </vs-td>
                  <vs-td :data="data[indextr].site_email">
                    {{ data[indextr].site_email }}
                  </vs-td>
                  <vs-td :data="data[indextr].is_approved">
                    <vs-chip transparent v-if="data[indextr].is_approved === 3 "  color="danger">
                      Not Approved
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 2 "  color="primary">
                      approved
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 1 "  color="warning">
                      Pending Approval
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 0"  color="danger">
                      Pending
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left" v-can="'view-site'">
                        <vs-button class="ml-3"
                                   @click.stop="onClickViewManufacturing(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-can="'view-site'"
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5"></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')

  import {defaultPagination, perPageList} from "@/constants/config";

  export default {
    name: 'ManufacturingManage',
    data () {
      return {
        manufacturing_sites: [],
        filters: {},
        page : 1,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect
    },
    mixins : [Filter],
    async mounted () {

      this.$refs.filterCard.isContentCollapsed = true
      this.$refs.filterCard.maxHeight = '1.5rem'
      this.$vs.loading()
      this.fetchManucaturingSite()
      this.$vs.loading.close()

    },
    methods: {
      async fetchManucaturingSite() {
        this.$vs.loading()
       try {
         const {data} = await SupplierManufactureRepository.getAllManufacturerSites(this.page, this.filterQuery, this.perPage, this.sort)
         this.manufacturing_sites =  data.data
         this.meta = data.meta
       } catch (e) {

       }
        this.$vs.loading.close()
      },
      onClickViewManufacturing(id) {
        if(this.$can('view-site')) {
          this.$router.push({path: `/pages/supplier-manufacturing/${id}`})
        }
      },
      onCLickCreateManufacturing() {
        this.$router.push({path: `/pages/supplier-manufacturing/create`})
      },

      filterQueryUpdate (){
        this.page = 1
        this.fetchManucaturingSite()
      },

      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchManucaturingSite()
        }

      }

    },
    watch : {
      page(){
        this.fetchManucaturingSite()
      },
      perPage() {
        this.fetchManucaturingSite()
      },
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
